<div (click)="open()">
  <ng-content></ng-content>
</div>

<ng-template #spaceCreationModal>
  <div class="modal-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit(model)">
    <div class="modal-header">
      <h5 class="modal-title">Create New Space</h5>
      <button type="button" class="btn-close m-0" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">

        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>


    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary">Create</button>
    </div>
  </form>
  </div>

</ng-template>
